// @ts-nocheck

import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

import { selectMatchUnachivedMissionId } from '../../modules/missions/selectors/banner';
import {
  selectEntitiesMatchesEntityBets,
  selectEntitiesMatchesEntityHallOfFameBetslips,
  selectEntitiesMatchesEntityIsOutright,
  selectEntitiesMatchesEntityMatchPromo,
  selectEntitiesMatchesEntityStatus,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import {
  selectIsMatchMultimatch,
  selectMatchCategoryPromo,
  selectMatchSportPromo,
  selectMatchTournamentPromo,
} from '../../selectors/match.selector';
import { selectRuntimeLicence } from '../../selectors/runtime/runtimePrimary.selector';
import {
  selectUserDidReceivedUserData,
  selectUserMissionsModerator,
  selectUserPromotionStatus,
} from '../../selectors/user/userPrimary.selector';
import { type StateType } from '../../states';
import { Licences } from '../../types/common';
import { PromotionStatuses } from '../../types/promotions';
import { entity as EntityUtils } from '../../utils';

const getMatchIdFromProps = (_: StateType, { matchId }) => matchId;

const makeMatchPropsSelector = () => {
  const selectStatus = createSelector([selectEntitiesMatchesEntityStatus], (status) =>
    EntityUtils.convertToLowerCase(status),
  );

  const selectMatchMissionId = createSelector(
    [
      selectMatchUnachivedMissionId,
      selectRuntimeLicence,
      selectUserMissionsModerator,
      selectUserPromotionStatus,
      selectUserDidReceivedUserData,
    ],
    (missionId, licence, missionsModerator, promotionStatus, didReceivedUserData) => {
      const allowConnectedEs = licence !== Licences.ES || didReceivedUserData;

      if (allowConnectedEs && promotionStatus === PromotionStatuses.DEFAULT && !missionsModerator) {
        return missionId;
      }
      return undefined;
    },
  );

  const selectMatchHasOdds = createSelector([selectEntitiesMatchesEntityBets], (betIds) => !isEmpty(betIds));

  return createSelector(
    [
      getMatchIdFromProps,
      selectEntitiesMatchesEntityHallOfFameBetslips,
      selectStatus,
      selectMatchSportPromo,
      selectMatchCategoryPromo,
      selectMatchTournamentPromo,
      selectEntitiesMatchesEntityMatchPromo,
      selectMatchMissionId,
      selectMatchHasOdds,
      selectEntitiesMatchesEntityIsOutright,
      selectIsMatchMultimatch,
    ],
    (
      matchId,
      hallOfFameBetslips,
      status,
      sportPromo,
      categoryPromo,
      tournamentPromo,
      matchPromo,
      missionId,
      hasOdds,
      isOutright,
      isMultimatch,
    ) => ({
      matchId,
      hallOfFameBetslips,
      status,
      sportPromo,
      categoryPromo,
      tournamentPromo,
      matchPromo,
      missionId,
      hasOdds,
      isOutright,
      isMultimatch,
    }),
  );
};

export default makeMatchPropsSelector;
